import React, { useEffect, useRef, useState } from 'react';
import { LoadBeeProps } from './LoadBeeProps';

const locale = 'en_GB';
const scriptUrl = 'https://cdn.loadbee.com/js/loadbee_integration.js';
const shop = 'ggvwRZ3EWPudZDu7ZYcAAyfbSLzS4g5b';

function LoadBee({ ean }: LoadBeeProps) {
  const divRef = useRef<HTMLDivElement>(null);
  const [iFrameLoaded, setIFrameLoaded] = useState(true);

  useEffect(() => {
    const checkForIframe = () => {
      if (divRef.current) {
        let interval: NodeJS.Timeout;
        let timeout: NodeJS.Timeout;

        // eslint-disable-next-line prefer-const
        interval = setInterval(() => {
          const iframe = divRef.current?.querySelector('iframe');
          if (iframe) {
            clearInterval(interval);
            clearTimeout(timeout);
          }
        }, 500);

        timeout = setTimeout(() => {
          clearInterval(interval);
          setIFrameLoaded(false);
        }, 5000);
      }
    };

    const delay = setTimeout(() => {
      checkForIframe();
      clearTimeout(delay);
    }, 5000);

    return () => clearTimeout(delay);
  }, [iFrameLoaded]);

  return iFrameLoaded ? (
    <>
      <div
        ref={divRef}
        className="loadbeeTabContent"
        data-loadbee-apikey={shop}
        data-loadbee-gtin={ean}
        data-loadbee-gtintype="ean"
        data-loadbee-locale={locale}
        data-testid="loadbee"
      />
      <script async src={scriptUrl} />
    </>
  ) : null;
}

export default LoadBee;
